import React from 'react';
import styled from 'styled-components';

import AncDiag from '../img/Anciano_Diagnostico.png';
import AncDiag2 from '../img/Anciano_Diagnostico2.png';
import AncDiag3 from '../img/Anciano_Diagnostico3.png';
import AncDiag4 from '../img/Anciano_Diagnostico4.png';

const Blog = () => {
    return (
        <Contenedor>
            <HEADER>
                <h1>Diagnostico</h1>
            </HEADER>
        
        <Contenedor2>
            <AncDiagnost src={AncDiag} />
            <UL>
                <LI>               
                    <div>   
                        <ul>                        
                            <li>Terapia psicológica para el paciente y la familia.</li>
                            <li>Asesoría sobre la zona de confort.</li>
                            <li>Asesorías sobre el proceso natural de la enfermedad.</li>
                            <li>Brindar calidad de vida.</li>
                            {/* <li>Valoración de entorno, el lugar donde duerme y habita revisando las estructuras y barreras de las cuales depende.</li>
                            <li><p>Valoración física y mental con escalas normativas para pacientes gerontologicos y geriatricos.</p></li>
                            <li><p>Valoración tanatológica para determinar los requerimientos que pudiera tener en sus trastornos (depreción y ansiedad).</p></li> */}
                            
                        </ul>
                    </div>
                </LI>
            </UL>
            
        </Contenedor2>
        <Contenedor2>
            <AncDiagnost3 src={AncDiag3} />
            <UL>
                <LI>               
                    <div>
                        <ul>
                            <li>Requerimientos alimentaros.</li>
                            <li>Valoración del cuidador para descartar Colapso.</li>
                            <li>Talleres para cuidadores primarios.</li>
                            <li>Acompañamiento tanatológico para la familia.</li>
                            {/*<li><p>Valoración de medicamentos.</p></li>
                            <li><p>Valoración de tipo de la marcha (el paciente necesita plantillas, faja, bastón, andadera).</p></li>
                            <li><p>Necesidad de rehabilitación física.</p></li>*/}
                        </ul>
                    </div>
                </LI>            
            </UL>
            
        </Contenedor2>
        <Contenedor2>
            <AncDiagnost2 src={AncDiag2} />
            <UL>
                <LI>
                    <div>
                        <ul>    
                            <li>Valoración de la marcha y equilibrio.</li>
                            <li>Terapia ocupacional y apoyo funcional.</li>
                            <li>Técnicas de movilización.</li>
                            <li>Valoración de la piel.</li>
                            {/* <li><p>Cuidados en la cama si tuviera inmobilidad completa.</p></li>
                            <li><p>Valoración de escaras para descartar problemas en la piel.</p></li>
                            <li><p>Técnicas para mobilizar al paciente para no dañar al cuidador.</p></li> */}
                        </ul>
                    </div>
                </LI>
            </UL>            
        </Contenedor2>
        <Contenedor2>
            <AncDiagnost4 src={AncDiag4} />
            <UL>
                <LI>
                    <div>
                        <ul>
                            <li>Valoración del entorno y barreras físicas y estructurales que evitan la movilidad.</li>
                            <li>Valoración con escalas normativas para enfermos geriátricos y pacientes con enfermedades terminales y crónico degenerativas.</li>
                            <li>Valoración psicológica para descartar padecimientos como ansiedad, miedo y depresión.</li>
                            <li>Valoración de la polifarmacia.</li>
                            {/* <li><p>Aseo y alimentación.</p></li>
                            <li><p>Determinar una zona de comfort para que su calidad de vida en general sea buena.</p></li>
                            <li><p>Escalas para familiares y cuidadores para determinar colapso del cuidador.</p></li>
                            <li><p>Terapias psicológicas.</p></li>
                            <li><p>Terapias tanatológicas para los familiares.</p></li> */}
                        </ul>
                    </div>                
                </LI>            
            </UL>
            
        </Contenedor2>            
        </Contenedor>
    );
}
 
const Contenedor = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 0rem 2rem;
    background: #00fff;
    
    
    
    @media (max-width: 420px) { 
        width: 100%;
        // max-width: 520px;
        font-size: 20px;
        color: #092c4c;
        background: #00fff;
        // padding: 0rem 10rem 0rem 0rem
      }
`;
const Contenedor2 = styled.div`
    width: 90%;
    margin: 2rem 2rem 0rem 2rem;
    display: flex;
    font-size: 14px;
    text-align: justify;

    @media (max-width: 420px) { 
        width: 95%;
        max-width: 420px;
        display: block;
        margin: 3rem 2rem 2rem 2rem;
      }
`
const HEADER = styled.div`
    width: 100%;
    margin: 0rem 0rem 0rem 0rem;    
    text-decoration: underline #092c4c;

    @media (max-width: 420px) { 
        font-size: 12px;
      }
`;
const UL = styled.ul`
    margin: 2rem 1rem 3rem 2rem;
    font-size: 14px;
    background-color: #F4F3EE;

    @media (max-width: 420px) { 
        width: 15rem;
        margin: 1rem 3rem 1rem 2rem;
        font-size: 12px;
        background-color: #F4F3EE;
      }
`
const LI = styled.ul`
    width: 35rem;
    margin: 4rem .1rem 0rem 6rem;
    text-decoration: #092c4c;
    text-align: justify;
    background-color: #F4F3EE;

    @media (max-width: 420px) { 
        width: 15rem;
        margin: 1rem 3rem 1rem 2rem;
        font-size: 12px;
        background-color: #F4F3EE;
      }
`
const AncDiagnost = styled.img`
    width: 18rem;
    height: 20rem;
    padding: 2rem .5rem 2rem .5rem;
`
const AncDiagnost2 = styled.img`
    width: 18rem;
    height: 20rem;
    padding: 2rem .5rem 2rem .5rem;
    border-radius: 60px;
`
const AncDiagnost3 = styled.img`
    width: 18rem;
    height: 23rem;
    padding: 2rem .5rem 2rem .5rem;
`
const AncDiagnost4 = styled.img`
    width: 15rem;
    height: 20rem;
    padding: 2rem .5rem 2rem .5rem;
`
export default Blog;